import 'core-js/modules/es.array.from';
import 'core-js/modules/es.array.fill';
import 'core-js/modules/es.array.find';
import 'core-js/modules/es.array.includes';

import 'core-js/modules/es.weak-set';
import 'core-js/modules/es.weak-map';
import 'core-js/modules/es.set';
import 'core-js/modules/es.map';

import 'core-js/modules/es.number.is-integer';
import 'core-js/modules/es.string.includes';
import 'core-js/modules/es.string.starts-with';

import 'core-js/modules/web.dom-collections.for-each';
import 'core-js/web/url-search-params';

import 'core-js/modules/es.promise.any';

if (typeof window.Event !== 'function') {
	const originalEvent = window.Event;
	window.Event = function (inType, params) {
		params = params || {};
		const e = document.createEvent('Event');
		e.initEvent(inType, Boolean(params.bubbles), Boolean(params.cancelable));
		return e;
	};
	if (originalEvent) {
		Object.keys(originalEvent).forEach((key) => {
			window.Event[key] = originalEvent[key];
		});
		window.Event.prototype = originalEvent.prototype;
	}
}
